import React, { useState, Fragment } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";
import DeleteIcon from "@material-ui/icons/Delete";
import { withStyles } from "@material-ui/core/styles";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import { withNotification } from "../notification/context";

const DELETE_USER = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      nRemoved
    }
  }
`;

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit
  }
});

const DeleteUser = ({ classes, openNotification, query, row }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={DELETE_USER}
      update={cache => {
        const { allUsers } = cache.readQuery({ query });
        cache.writeQuery({
          query,
          data: {
            allUsers: allUsers.filter(item => item.id !== row.id)
          }
        });
      }}
    >
      {createUser => {
        const deleteUserFn = () => {
          createUser({ variables: { id: row.id } })
            .then(() => {
              openNotification("Usuario eliminado correctamente.");
              handleClose();
            })
            .catch(() => {
              openNotification("Error eliminando el usuario");
              //handleClose();
            });
        };
        return (
          <Fragment>
            <Fab size="small" className={classes.fab} onClick={handleClickOpen}>
              <DeleteIcon />
            </Fab>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Eliminar usuario</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  ¿Está seguro que desea eliminar el usuario {row.email}?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  Cancelar
                </Button>
                <Button onClick={deleteUserFn} color="secondary">
                  Eliminar
                </Button>
              </DialogActions>
            </Dialog>
          </Fragment>
        );
      }}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(DeleteUser);



// WEBPACK FOOTER //
// ./src/components/users/delete-user-button.js